import React, { Component } from 'react';
import { Table, Row, InputNumber, Select, Button, message } from 'antd';
import moment from 'moment';
import './index.scss';
import imgSave from "../../../bp-views/table/saveImg";
import { data2_1 } from './data';
import Auth from "../../table/Auth";
import TableText from "../../../hr/components/TableText";
import getJson from "../../../method";

const Option = Select.Option;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        const month = moment().format('M');
        this.state = {
            date: month < 3 ? moment().format('YYYY') : moment().add(1, 'y').format('YYYY'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            dateData: [],
            cover: 0,
            dataSelect: []
        }
    }


    componentDidMount() {
        let date = Number(this.state.date || "0");
        let dateData = [];
        let len = date - 2018 + 3;
        for (let i = 0; i < len; i++) {
            dateData.push((2018 + i).toString())
        }
        this.setState({ dateData });
        this.getDateData(this.state.date);
    }

    computeNum = (data) => {
        const numConvert = (num = 0) => {
            num = Number(num || "0")
            return num
        }

        const listName = ['month_actual', 'month_budget', 'month_last', 'year_actual', 'year_budget', 'year_last'];
        //14 单独
        const formula = [
            [7, 10], [8, 10], [9, 10], [10, 10], [12, 8], [13, 9],
        ];


        listName.forEach((name, index) => {
            data[14][name + "_percent"] = ((numConvert(data[8][name]) + numConvert(data[8][name])) == 0 ? 0 : data[14][name] / (numConvert(data[8][name]) + numConvert(data[8][name]))).toFixed(4);
            formula.forEach((x, i) => {
                data[x[0]][name + "_percent"] = (numConvert(data[x[1]][name]) == 0 ? 0 : numConvert(data[x[0]][name]) / numConvert(data[x[1]][name])).toFixed(4);
            });
            data.forEach((item, i) => {
                if (i >= 16) {
                    data[i][name + '_percent'] = (numConvert(data[10][name]) == 0 ? 0 : numConvert(data[i][name]) / numConvert(data[10][name])).toFixed(3);
                }
            });
        });

        this.setState({
            data,
        });
    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getDateData = async (date) => {
        const dataBegin = JSON.stringify(data2_1);
        let data = JSON.parse(dataBegin);
        try {
            let res = await fetch(`/charter_summary?year=${moment(date).format('YYYY')}`, { credentials: 'include' });
            let json = await res.json();
            const one = json.data.one || [];
            const two = json.data.two || [];
            const three = json.data.three || [];
            const four = json.data.four || [];
            const lastone = json.data.lastone || [];
            const lasttwo = json.data.lasttwo || [];
            const lastthree = json.data.lastthree || [];
            const lastfour = json.data.lastfour || [];

            const month = moment().format('M') - 1;
            const monthname = ['Jan', 'Feb', 'Mar', 'Jan', 'Feb', 'Mar', 'Jan', 'Feb', 'Mar', 'Jan', 'Feb', 'Mar'];
            const dataList = [one, one, one, two, two, two, three, three, three, four, four, four];
            const dataLastList = [lastone, lastone, lastone, lasttwo, lasttwo, lasttwo, lastthree, lastthree, lastthree, lastfour, lastfour, lastfour];

            let name = monthname[month];
            let dataSource = dataList[month];
            let dataLastSource = dataLastList[month];
            data = data.map((item, i) => {
                return {
                    ...item,
                    month_actual: getJson([i, name + "_actual"], dataSource),
                    month_budget: getJson([i, name + "_budget"], dataSource),
                    month_last: getJson([i, name + "_actual"], dataLastSource),
                    year_actual: dataList.reduce((a, b, index) => {
                        a += Number(getJson([i, monthname[index] + '_actual'], b));
                        return a;
                    }, 0),
                    year_budget: dataList.reduce((a, b, index) => {
                        a += Number(getJson([i, monthname[index] + '_budget'], b));
                        return a;
                    }, 0),
                    year_last: dataLastList.reduce((a, b, index) => {
                        a += Number(getJson([i, monthname[index] + '_actual'], b));
                        return a;
                    }, 0),
                }
            });

            this.setState({ loading: false, }, () => {
                this.computeNum(data);
            });
        } catch (error) {
            this.setState({ loading: false });
            console.error(error);
        }
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table2_1', 1.5, '0.50', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const data = this.state.data;
        const width = document.body.offsetWidth > 2225 ? document.body.offsetWidth - 1800 : 425;
        const percentData = [3, 63, 64, 65, 66, 67, 68, 69, 70];
        const totalData = [10, 35, 55];
        const blankData = [6, 11, 15, 20, 25, 31, 36, 37, 43, 56, 62];
        const columns = [
            // {
            //     align: "center",
            //     title: 'key',
            //     width: 50,
            //     fixed: 'left',
            //     render: (text, record, index) => {
            //         return index
            //     }
            // },
            {
                align: "center",
                title: '',
                width,
                fixed: 'left',
                dataIndex: 'name',
                key: 'name',
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'text', name: "name", onChange: this.onChange, totalIndex: totalData,

                    };
                    if (blankData.includes(index)) {
                        return {
                            props: { colSpan: 16 },
                            children: <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                                {text}
                            </div>
                        }
                    }

                    return <TableText data={{ ...props }} />
                }
            }, {
                title: 'THIS MONTH 本月',
                align: "center",
                children: [{
                    title: 'ACTUAL  实际',
                    align: "center",
                    width: 150,
                    dataIndex: 'month_actual',
                    key: 'month_actual',
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: percentData.includes(index) ? 'percent' : "number", name: "Jan_actual", onChange: this.onChange, totalIndex: totalData,
                        };
                        if (blankData.includes(index)) {
                            return {
                                props: {
                                    colSpan: 0,
                                    children: ""
                                }
                            }
                        }
                        return <TableText data={{ ...props, }} />

                    }
                }]
            }, {
                title: '(%)',
                align: "center",
                dataIndex: 'month_actual_percent',
                key: 'month_actual_percent',
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'percent', name: "month_actual_percent", onChange: this.onChange, totalIndex: totalData,
                    };
                    if (blankData.includes(index)) {
                        return {
                            props: {
                                colSpan: 0,
                                children: ""
                            }
                        }
                    }
                    return <TableText data={{ ...props, }} />

                }
            }, {
                title: 'THIS MONTH 本月',
                align: "center",
                children: [{
                    title: 'BUDGET  预算',
                    align: "center",
                    width: 150,
                    dataIndex: 'month_budget',
                    key: 'month_budget',
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: percentData.includes(index) ? 'percent' : "number", name: "month_budget", onChange: this.onChange, totalIndex: totalData,
                        };
                        if (blankData.includes(index)) {
                            return {
                                props: {
                                    colSpan: 0,
                                    children: ""
                                }
                            }
                        }
                        return <TableText data={{ ...props, }} />

                    }
                }]
            }, {
                title: '(%)',
                align: "center",
                dataIndex: 'month_budget_percent',
                key: 'month_budget_percent',
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'percent', name: "month_budget_percent", onChange: this.onChange, totalIndex: totalData,
                    };
                    if (blankData.includes(index)) {
                        return {
                            props: {
                                colSpan: 0,
                                children: ""
                            }
                        }
                    }
                    return <TableText data={{ ...props, }} />

                }
            }, {
                title: 'THIS MONTH 本月',
                align: "center",
                children: [{
                    title: 'LAST YEAR  上年',
                    align: "center",
                    width: 150,
                    dataIndex: 'month_last',
                    key: 'month_last',
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: percentData.includes(index) ? 'percent' : "number", name: "month_last", onChange: this.onChange, totalIndex: totalData,
                        };
                        if (blankData.includes(index)) {
                            return {
                                props: {
                                    colSpan: 0,
                                    children: ""
                                }
                            }
                        }
                        return <TableText data={{ ...props, }} />

                    }
                }]
            }, {
                title: '(%)',
                align: "center",
                dataIndex: 'month_last_percent',
                key: 'month_last_percent',
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'percent', name: "month_last_percent", onChange: this.onChange, totalIndex: totalData,
                    };
                    if (blankData.includes(index)) {
                        return {
                            props: {
                                colSpan: 0,
                                children: ""
                            }
                        }
                    }
                    return <TableText data={{ ...props, }} />

                }
            }, {
                title: 'Y-T-D  本年累计',
                align: "center",
                children: [{
                    title: 'ACTUAL  实际',
                    align: "center",
                    width: 150,
                    dataIndex: 'year_actual',
                    key: 'year_actual',
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: percentData.includes(index) ? 'percent' : "number", name: "year_actual", onChange: this.onChange, totalIndex: totalData,
                        };
                        if (blankData.includes(index)) {
                            return {
                                props: {
                                    colSpan: 0,
                                    children: ""
                                }
                            }
                        }
                        return <TableText data={{ ...props, }} />

                    }
                }]
            }, {
                title: '(%)',
                align: "center",
                dataIndex: 'year_actual_percent',
                key: 'year_actual_percent',
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'percent', name: "year_actual_percent", onChange: this.onChange, totalIndex: totalData,
                    };
                    if (blankData.includes(index)) {
                        return {
                            props: {
                                colSpan: 0,
                                children: ""
                            }
                        }
                    }
                    return <TableText data={{ ...props, }} />

                }
            }, {
                title: 'Y-T-D  本年累计',
                align: "center",
                children: [{
                    title: 'BUDGET  预算',
                    align: "center",
                    width: 150,
                    dataIndex: 'year_budget',
                    key: 'year_budget',
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: percentData.includes(index) ? 'percent' : "number", name: "year_budget", onChange: this.onChange, totalIndex: totalData,
                        };
                        if (blankData.includes(index)) {
                            return {
                                props: {
                                    colSpan: 0,
                                    children: ""
                                }
                            }
                        }
                        return <TableText data={{ ...props, }} />

                    }
                }]
            }, {
                title: '(%)',
                align: "center",
                dataIndex: 'year_budget_percent',
                key: 'year_budget_percent',
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'percent', name: "year_budget_percent", onChange: this.onChange, totalIndex: totalData,
                    };
                    if (blankData.includes(index)) {
                        return {
                            props: {
                                colSpan: 0,
                                children: ""
                            }
                        }
                    }
                    return <TableText data={{ ...props, }} />

                }
            }, {
                title: 'Y-T-D  年累计',
                align: "center",
                children: [{
                    title: 'LAST YEAR  上年',
                    align: "center",
                    width: 150,
                    dataIndex: 'year_last',
                    key: 'year_last',
                    render: (text, record, index) => {
                        const props = {
                            text, index, type: percentData.includes(index) ? 'percent' : "number", name: "year_last", onChange: this.onChange, totalIndex: totalData,
                        };
                        if (blankData.includes(index)) {
                            return {
                                props: {
                                    colSpan: 0,
                                    children: ""
                                }
                            }
                        }
                        return <TableText data={{ ...props, }} />

                    }
                }]
            }, {
                title: '(%)',
                align: "center",
                dataIndex: 'year_last_percent',
                key: 'year_last_percent',
                width: 150,
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'percent', name: "year_last_percent", onChange: this.onChange, totalIndex: totalData,
                    };
                    if (blankData.includes(index)) {
                        return {
                            props: {
                                colSpan: 0,
                                children: ""
                            }
                        }
                    }
                    return <TableText data={{ ...props, }} />

                }
            }];
        return (
            <div className="table table2_1">
                <Row className="title" style={{ width: this.state.print ? 1775 : 'auto' }} id="table2_1">
                    <Row>Summary Table 汇总表</Row>
                    <Row className="table-month">
                        <Select
                            placeholder="请选择年份"
                            style={{ width: 120 }}
                            value={this.state.date}
                            onChange={(str) => {
                                this.setState({
                                    date: str,
                                    data: [],
                                    loading: true
                                });
                                this.getDateData(str)
                            }}
                        >
                            {this.state.dateData.map((x, i) => {
                                return (
                                    <Option value={x} key={x}>{x}年</Option>
                                )
                            })}
                        </Select>
                    </Row>
                    <Table
                        columns={columns}
                        dataSource={data}
                        size="middle"
                        className="content"
                        bordered
                        loading={this.state.loading}
                        pagination={false}
                        style={{ width: this.state.print ? 2225 : 'auto' }}
                        scroll={this.state.print ? {} : { y: 500, x: 2225 }}
                        rowKey={(record, index) => {
                            return index
                        }}
                    />

                </Row>
                <Auth loading={this.state.loading} auth='edit_summary'>
                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={this.downloadSG}
                            loading={this.state.print}
                        >加入pdf</Button>
                    </Row>
                </Auth>

            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/charter/summary/index.js